export const getWorkspaceReservationLabel = ({
  buildingName,
  floorName,
  areaName,
  deskName,
}: {
  buildingName?: string;
  floorName?: string;
  areaName?: string;
  deskName?: string;
}) => {
  return [buildingName, floorName, areaName, deskName].filter(Boolean).join(', ');
};

export const getParkingReservationLabel = ({
  parkingLotName,
  parkingZoneName,
}: {
  parkingLotName?: string;
  parkingZoneName?: string;
}) => {
  return [parkingLotName, parkingZoneName].filter(Boolean).join(', ');
};
